export const SUPPORT_TOKEN_KEY = "cosm_support_token";
export const ADMIN_TOKEN_KEY = "cosm_token";

// A support session belongs to this tab only; other tabs retain the admin identity.
export const getActiveToken = () =>
  sessionStorage.getItem(SUPPORT_TOKEN_KEY) || localStorage.getItem(ADMIN_TOKEN_KEY);